export default "__VITE_ASSET__5141504a__"